<template>
    <div class="entry-status">
        <h4>Visitantes</h4>
        <div class="table-responsive">
            <table class="table table-sm table-hover table-bordered table-striped">
                <thead class="thead-orange">
                    <tr>
                        <th></th>
                        <th>Internos</th>
                        <th>Externos</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Personas</td>
                        <td>{{ internalsPersonCount }}</td>
                        <td>{{ externalsPersonCount }}</td>
                    </tr>
                    <tr>
                        <td>Vehiculos</td>
                        <td>{{ internalsVehicleCount }}</td>
                        <td>{{ externalsVehicleCount }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        computed:{
            ...mapGetters(['personEntries', 'vehicleEntries']),
            internalsPersonCount(){
                let internals = this.personEntries.filter(item => !!item.person.internal);
                return internals.length;
            },
            externalsPersonCount(){
                let externals = this.personEntries.filter(item => !item.person.internal);
                return externals.length;
            },
            internalsVehicleCount(){
                let internals = this.vehicleEntries.filter(item => !!item.vehicle.internal);
                return internals.length;
            },
            externalsVehicleCount(){
                let externals = this.vehicleEntries.filter(item => !item.vehicle.internal);
                return externals.length;
            },
        }
    }
</script>